import React from "react";
import Sidebar from "../components/sidebar";
import Header from "./../components/Header";
import MainUser from "../components/users/MainUser";

const UsersScreen = () => {
  return (
    <>
      <Sidebar />
      <main className="main-wrap">
        <Header />
        <MainUser />
      </main>
    </>
  );
};

export default UsersScreen;
